function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2604",
  "data-name": "Group 2604",
  transform: "translate(-221.942 -442.368)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2573",
  "data-name": "Group 2573",
  transform: "translate(-55.785 525.125)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_562",
  "data-name": "Line 562",
  x2: 64,
  transform: "translate(280.285 -72.625)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3677",
  "data-name": "Path 3677",
  d: "M279.842-66.342a5.185,5.185,0,0,1,6.158,0c3.539,2.241,3.891,3.5,9.02,2.8s4.742-3.881,10.775-2.8,4.795,4.056,12.543,2.8,5.516-3.693,11.666-2.8,6.445,5.077,11.213,3.837,3.947-3.837,3.947-3.837",
  transform: "translate(0 4)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_165",
  "data-name": "Ellipse 165",
  transform: "translate(279.785 -55.125)",
  fill: "none",
  stroke: "#a64daa",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_166",
  "data-name": "Ellipse 166",
  transform: "translate(298.786 -55.125)",
  fill: "none",
  stroke: "#a64daa",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_167",
  "data-name": "Ellipse 167",
  transform: "translate(316.785 -55.125)",
  fill: "none",
  stroke: "#a64daa",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_169",
  "data-name": "Ellipse 169",
  transform: "translate(326.785 -45.125)",
  fill: "none",
  stroke: "#a64daa",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_170",
  "data-name": "Ellipse 170",
  transform: "translate(308.785 -45.125)",
  fill: "none",
  stroke: "#a64daa",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_171",
  "data-name": "Ellipse 171",
  transform: "translate(288.785 -44.125)",
  fill: "none",
  stroke: "#a64daa",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_172",
  "data-name": "Ellipse 172",
  transform: "translate(300.785 -38.125)",
  fill: "none",
  stroke: "#a64daa",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_173",
  "data-name": "Ellipse 173",
  transform: "translate(320.785 -38.125)",
  fill: "none",
  stroke: "#a64daa",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_174",
  "data-name": "Ellipse 174",
  transform: "translate(339.785 -38.125)",
  fill: "none",
  stroke: "#a64daa",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_175",
  "data-name": "Ellipse 175",
  transform: "translate(279.785 -38.125)",
  fill: "none",
  stroke: "#a64daa",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_168",
  "data-name": "Ellipse 168",
  transform: "translate(335.785 -55.125)",
  fill: "none",
  stroke: "#a64daa",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 3.5,
  fill: "none"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_3676",
  "data-name": "Path 3676",
  d: "M-22775-2154.688s2.039,5.2,11.262,2.689",
  transform: "translate(23013 2599)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeWidth: 3
}));

var SvgCombinationSkinFeelIcon = function SvgCombinationSkinFeelIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69.011,
    height: 50.632,
    viewBox: "0 0 69.011 50.632",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCombinationSkinFeelIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/combinationSkinFeel-icon.5e9b2345.svg";
export { ForwardRef as ReactComponent };